import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { ActivatedRouteSnapshot, Router } from "@angular/router";
import { Observable, Subject } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class PiService {
  private readonly reloadPIListSource = new Subject<void>();
  private readonly pIFilterResetSource = new Subject<void>();
  private readonly pIPortfolioFilterSource = new Subject<any>();
  reloadPIList$ = this.reloadPIListSource.asObservable();
  pIFilterReset$ = this.pIFilterResetSource.asObservable();
  pIPortfolioFilterReset$ = this.pIPortfolioFilterSource.asObservable();

  constructor(
    private readonly http: HttpClient,
    private readonly router: Router
  ) { }

  triggerReload() {
    this.reloadPIListSource.next();
  }

  triggerFilterReset() {
    this.pIFilterResetSource.next();
  }

  triggerPortfolioFilterReset(remainingFilterCfgs: any) {
    this.pIPortfolioFilterSource.next(remainingFilterCfgs);
  }

  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    let id = route.params["id"];
    try {
      id = atob(id);
    } catch (e) {
      this.router.navigate(["404"]);
    }
    return this.http.get("pi/program-increment/");
  }

  getAllProgramIncrements(moduleName: string = '') {
    return this.http.get(`pi/program-increment/?module=${moduleName}`);
  }

  getProgramIncrementbyID(id: number, moduleName: string = '') {
    return this.http.get(`pi/program-increment/${id}/?module=${moduleName}`);
  }

  createProgramIncrement(payload: any) {
    return this.http.post("pi/program-increment/", payload);
  }

  updateProgramIncrement(id: number, payload: any, moduleName: string = '') {
    return this.http.patch(`pi/program-increment/${id}/?module=${moduleName}`, payload);
  }

  downloadFile(id: number) {
    return this.http.get(`pi/program-increment/download-file/?file_id=${id}`,
      { responseType: "blob" });
  }

  deleteFile(id: number) {
    return this.http.delete(`pi/program-increment/delete-file/?file_id=${id}`);
  }

  deleteProgramIncrement(id: number, moduleName: string = '') {
    return this.http.delete(`pi/program-increment/${id}/?module=${moduleName}`);
  }

  getFilteredProgramIncrements(qParam: string, moduleName: string = '') {
    return this.http.get(`pi/program-increment/?${qParam}&module=${moduleName}`);
  }

  getProgramIncrementNames(moduleName: string = '') {
    return this.http.get(`pi/program-increment/names/?module=${moduleName}`);
  }

  getUser() {
    return this.http.get(`users/user-list/`);
  }
}
